import styled from 'styled-components';
import { NavBarHeight, SubNavBarHeight } from '../../../const';

export const BackButtonContainer = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  padding: 12px 0;
  position: sticky;
  top: calc(${NavBarHeight}px + ${SubNavBarHeight}px);
  width: 100vw;
  background: ${({ theme }) => theme.colors.white};
  z-index: ${(props) => props.theme.zIndex.navBar - 2};
  box-shadow: 0px 7px 10px 1px rgb(27 27 27 / 45%);
`;
